// import './_language.js';

window.addEventListener("load", function () {

  // Nút bật/tắt âm thanh: đổi icon sprite music <-> music-off và play/pause nhạc nền (#bgm nếu có)
  const $btnMusic = $(".btn-music");
  const bgm = document.getElementById("bgm"); // <audio id="bgm"> — thêm sau khi có file nhạc

  // Bật/tắt nhạc theo trạng thái mong muốn
  function setMusic(on) {
    if (on) {
      $btnMusic.removeClass("mute").addClass("is-on");
      if (bgm) bgm.play().catch(function () {}); // bỏ qua lỗi autoplay policy
    } else {
      $btnMusic.removeClass("is-on").addClass("mute");
      if (bgm) bgm.pause();
    }
  }

  // Mặc định khi load trang: tắt tiếng
  setMusic(false);

  // Nút bấm: toggle thủ công
  $btnMusic.on("click", function (e) {
    e.preventDefault();
    setMusic($btnMusic.hasClass("mute")); // đang mute -> bật, đang bật -> tắt
  });

  // Tự mở nhạc ở lần click chuột ĐẦU TIÊN của user (vượt qua chặn autoplay của trình duyệt)
  function autoStartOnce() {
    setMusic(true);
    document.removeEventListener("click", autoStartOnce);
  }
  document.addEventListener("click", autoStartOnce);

});

